import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: '[modal]',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @Input() showModal: boolean = false; 
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();


  public close() {
    this.modal.nativeElement.classList.add('close')
    setTimeout(() => {
      this.closeModal.emit(false);
      this.modal.nativeElement.classList.remove('close')
    }, 300);
  }

}
